import { Injectable } from '@angular/core';
import { BaseHttpService } from '../../shared/services/base-http.service';
import { Observable } from 'rxjs/Rx';
import {Store} from '@ngrx/store';
import {Response, Headers, RequestOptionsArgs, RequestOptions, Http} from '@angular/http';

import { IApplicationState } from '../../stateManagement/states/applicationState';
import * as authenticationTypes from '../types';

@Injectable()
export class AuthenticationService extends BaseHttpService {

  constructor(private http: Http, store: Store<IApplicationState>) {
    super(store);
  }

  authenticate(credentials: authenticationTypes.ICredentials): Observable<authenticationTypes.ILoginResult> {
    return this.http.post('auth/login', credentials).map(res => res.json());
  }

  resetPassword(resetData: authenticationTypes.ICredentials): Observable<authenticationTypes.IAuthenticationResult> {
    return this.http.post('auth/resetPassword', resetData).map(res => res.json());
  }

  updatePassword(updateData: authenticationTypes.IUpdatePassword): Observable<authenticationTypes.IAuthenticationResult> {
    return this.http.patch(`user/${this.userId}/password`, updateData, this.authorizedHttpOptions()).map(res => res.json());
  }

  saveMfaAuthType(mfaAuthTypeData: any): Observable<authenticationTypes.IMfaAuthCodeType> {
    return this.http.patch(`user/${this.userId}/savemfaauthtype`, mfaAuthTypeData, this.authorizedHttpOptions()).map(res => res.json());
  }

  resendMfaCode() {
    return this.http.get(`user/${this.userId}/sendmfacode`, this.authorizedHttpOptions()).map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/services/authentication.service.ts